import { useState } from 'react';
import FAQSchema from '../../seo/FAQSchema';
import '../Homepage/FAQ.css';

const TikTokLiveFAQs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      id: 1,
      question: 'How do you handle viral TikTok order spikes?',
      answer: 'We scale operations instantly with dedicated picking teams, batching by SKU and automated label workflows to clear spikes fast.'
    },
    {
      id: 2,
      question: 'What is your dispatch cut-off?',
      answer: 'Same-day dispatch for orders placed before the agreed cutoff (often 1–3pm), with on-time performance reporting.'
    },
    {
      id: 3,
      question: 'How does TikTok Shop integration work?',
      answer: 'Yes. We connect via real-time API so orders import automatically, inventory syncs back and tracking updates post immediately.'
    },
    {
      id: 4,
      question: 'Can you manage viral campaigns?',
      answer: 'Yes. We pre-stage hot SKUs, expand packing pods and run wave picking to sustain high throughput during viral surges.'
    },
    {
      id: 5,
      question: 'Do you support returns?',
      answer: 'Yes. Returns are scanned and graded within 24–48 hours, with restock or quarantine per your SOPs.'
    },
    {
      id: 6,
      question: 'How is tracking updated?',
      answer: 'Tracking is uploaded right after label generation to protect seller metrics and customer notifications.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqs-section">
      <FAQSchema
        faqs={faqs.map(({ question, answer }) => ({ question, answer }))}
        id="tiktok-live-faq-schema"
        nonce="ppp-2026-gtm-nonce"
      />
      <div className="faqs-container">
        <div className="faqs-header">
          <h2 className="faqs-title">TikTok Live Fulfilment FAQs</h2>
          <p className="faqs-description">
            Find answers to common questions about TikTok Shop fulfilment UK, TikTok Live order processing, shipping, returns, and onboarding.
          </p>
        </div>

        <div className="faqs-content">
          <div className="faqs-list">
            {faqs.map((faq, index) => (
              <div 
                key={faq.id} 
                className={`faq-item ${openIndex === index ? 'faq-open' : ''}`}
              >
                <div 
                  className="faq-question-wrapper"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="faq-question">{faq.question}</h3>
                  <button 
                    className={`faq-toggle ${openIndex === index ? 'faq-toggle-open' : ''}`}
                    aria-label={openIndex === index ? 'Close answer' : 'Open answer'}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFAQ(index);
                    }}
                  >
                    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
                      {openIndex === index ? (
                        <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                      ) : (
                        <>
                          <path d="M10 5V15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                          <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                <div className={`faq-answer ${openIndex === index ? 'faq-answer-open' : ''}`}>
                  <p><strong>Answer: </strong>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faqs-image-wrapper">
            <img 
              src="/Images/merchent/FAQ_image.webp" 
              alt="TikTok fulfilment FAQs" 
              className="faqs-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TikTokLiveFAQs;

